function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.6374 13.2119V18.3643V23.5167L35.7341 25.8977",
  stroke: "white",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 20.0429L30.4924 8.33301L38.299 13.2121L26.5891 20.0429L38.299 27.3616V38.0958L30.4924 42.487L10 30.777V20.0429Z",
  stroke: "white",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.855 8.33301V18.0913",
  stroke: "white",
  strokeWidth: 1.66667
}), /*#__PURE__*/React.createElement("path", {
  d: "M25 20V28.3333",
  stroke: "white",
  strokeWidth: 1.66667
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.8334 31.667V42.4011",
  stroke: "white",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3625 20.043L30.8549 31.7529L38.1736 27.3617",
  stroke: "white",
  strokeWidth: 2.5
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: -3.33,
  y: -1.66,
  width: 56.66,
  height: 56.66,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.67
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.665
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgDollhouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollhouse);
export default __webpack_public_path__ + "static/media/dollhouse.e10ebec4.svg";
export { ForwardRef as ReactComponent };